/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recover_Account_Password_ForgottenInputs */



/**
* | output |
* | --- |
* | "Activate my account / Forgot password?" |
*
* @param {Recover_Account_Password_ForgottenInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const recover_account_password_forgotten = /** @type {((inputs?: Recover_Account_Password_ForgottenInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recover_Account_Password_ForgottenInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Activate my account / Forgot password?")
	return /** @type {LocalizedString} */ ("Activer mon compte / Mot de passe oublié ?")
});